import { MultilineInput, Span } from "@tblabs/truffle";
import { Table } from "@tblabs/truffle/Controls/TableBuilder/Table";
import { PaymentForm, PaymentFormNames } from "../../../Models/Payment/PaymentForm";
import { TimeUtils } from "../../../Utils/TimeUtils";
import { PaymentStepData } from "../Models/PaymentStepData";


export class PaymentInfoForCustomer extends Table
{
    constructor(payment: PaymentStepData)
    {
        super();

        this.Class("payment-info-table");

        this.AddRow("Forma", PaymentFormNames[payment.Form.value])
        
        switch (payment.Form.value)
        {
            default:
            case PaymentForm.BankTransfer:
                this.AddRow("Numer konta", "88 1140 2004 0000 3102 7986 6622")
                    .AddRow("Adresat", "specTeam")
                    .AddRow("Tytułem", payment.Title.value)
                    .AddRow("Kwota", new Span(payment.AmountAsString).Attribute("data-testid", "payment-info-amount"))
                    .AddRow("Typ", "elixir (nie express!)")
                break;

            case PaymentForm.Blik:
                this.AddRow("Na numer", "507-293-714")
                    .AddRow("Tytułem", payment.Title.value)
                    .AddRow("Kwota", new Span(payment.AmountAsString).Attribute("data-testid", "payment-info-amount"))
                break;

            case PaymentForm.Cash:
                this.AddRow("Kwota", new Span(payment.AmountAsString).Attribute("data-testid", "payment-info-amount"))
                break;

            case PaymentForm.Crypto:
                const btcAmount = (payment.Amount.value / payment.ExchangeRate.value).toFixed(8);
                this.AddRow("Adres portfela", new MultilineInput("bc1qu72c9tuwjtgghmqtvgc0lhxt7n928hhn3ldyx8").Readonly().Rows(2).Background("none").BorderNone().Padding(0).Margin(0).Color("#000"))
                    .AddRow("Kwota", payment.AmountAsString)
                    .AddRow("Do przelania", new Span(btcAmount + " " + payment.PaymentCurrency.value).Bold())
                    .AddRow("Kurs BTC", payment.ExchangeRate.value.toString() + " PLN za 1 BTC")
                break;
        }

        this.AddRow("Termin", "Do " +TimeUtils.FormattedDate(payment.Deadline.value))
    }
}
